import React, { useContext, useEffect, useState } from "react";
import CategoryPie from "../components/Analytics/CategoryPie";
import TicketChart from "../components/Analytics/TicketChart";
import StateContext from "../context/state/StateContext";
import UserContext from "../context/user/UserContext";
import { MultipleLine } from "../components/Analytics/MultipleLine";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import styles from "../styles/analytics.module.css"; // Import the CSS module
import axios from "axios";

const Analytics = () => {
  const { getTickets, user, getEmployees } = useContext(UserContext);
  const {
    setModal,
    token,
    employees,
    tickets,
    setTickets,
    allTickets,
    setAllTickets,
  } = useContext(StateContext);
  const [userAnalytics, setUserAnalytics] = useState([]);
  const url = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getTickets();
    getEmployees();
    fetchUserAnalytics();
    fetchYearlyData();
  }, []);

  const fetchUserAnalytics = async () => {
    try {
      const response = await fetch(url + "api/ticket/analytics  ", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch analytics data");
      }
      const result = await response.json();
      if (result.success) {
        setUserAnalytics(result.data);
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Error fetching analytics data", error);
    }
  };

  const getInitials = (fullName) => {
    const names = fullName.split(" ");
    const initials = names.map((name) => name.charAt(0)).join("");
    return initials.toUpperCase();
  };

  function getRandomColor() {
    // Generate a random hexadecimal color code
    const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    return randomColor;
  }

  // getting pieChart data from tickets
  const categoryColors = [
    { fill: "#FF5733" }, // Vivid Red-Orange
    { fill: "#33B5FF" }, // Bright Sky Blue
    { fill: "#28B463" }, // Emerald Green
    { fill: "#FFC300" }, // Golden Yellow
    { fill: "#9B59B6" }, // Purple
    { fill: "#F39C12" }, // Orange-Yellow
  ];

  const analyticsColor = [
    { fill: "#FF6347" }, // Red-like color for overdue
    { fill: "#FFD700" }, // Yellow for pending
    { fill: "#1E90FF" }, // Blue for in progress
    { fill: "#32CD32" }, // Green for completed
    { fill: "#00FA9A" }, // Mint green for on-time
    { fill: "red" }, // Orange for delayed
  ];

  const ticketCounts = allTickets.reduce((acc, ticket) => {
    if (acc[ticket.category]) {
      acc[ticket.category].count++;
    } else {
      acc[ticket.category] = { count: 1 };
    }
    return acc;
  }, {});

  const aggregatedAnalytics = userAnalytics.reduce(
    (acc, currUser) => {
      acc.overdue += currUser.analytics.overdue;
      acc.pending += currUser.analytics.pending;
      acc.inprogress += currUser.analytics.inprogress;
      acc.completed += currUser.analytics.completed;
      acc.submittedOnTime += currUser.analytics.submittedOnTime;
      acc.delayed += currUser.analytics.delayed;
      return acc;
    },
    {
      overdue: 0,
      pending: 0,
      inprogress: 0,
      completed: 0,
      submittedOnTime: 0,
      delayed: 0,
    }
  );

  // Create the data array for the pie chart
  const progressCounts = [
    { category: "Overdue", count: aggregatedAnalytics.overdue },
    { category: "Pending", count: aggregatedAnalytics.pending },
    { category: "In Progress", count: aggregatedAnalytics.inprogress },
    { category: "Completed", count: aggregatedAnalytics.completed },
    { category: "On Time", count: aggregatedAnalytics.submittedOnTime },
    { category: "Delayed", count: aggregatedAnalytics.delayed },
  ];

  const chartData = Object.keys(ticketCounts).map((category, index) => ({
    category,
    tickets: ticketCounts[category].count,
    // fill: categoryColors[index] ? categoryColors[index].fill : ""
    fill: getRandomColor(),
  }));

  const analyticsData = progressCounts.map((data, index) => ({
    category: data.category,
    tickets: data.count,
    fill: analyticsColor[index % analyticsColor.length]
      ? analyticsColor[index % analyticsColor.length].fill
      : "", // Wrap colors if not enough
  }));

  const data = new Date().toLocaleDateString;
  // getting lineChart data from tickets

  const months = [
    { month: "January" },
    { month: "February" },
    { month: "March" },
    { month: "April" },
    { month: "May" },
    { month: "June" },
    { month: "July" },
    { month: "August" },
    { month: "September" },
    { month: "October" },
    { month: "November" },
    { month: "December" },
  ];

  // Function to count tickets by year and month and return the desired JSON format
  const generateYearlyData = (tickets) => {
    if(tickets){

      const yearlyData = {};
      
      // Get the current year
      const currentYear = new Date().getFullYear();
      
      // Define a range of years to include
      const startYear = 2024; // Example: Start from 2020
      const endYear = currentYear; // Up to the current year
      
      // Prepopulate yearlyData with all years in the range, with months initialized to 0
      for (let year = startYear; year <= endYear; year++) {
        yearlyData[year] = months.map((month) => ({ ...month, ticket: 0 }));
      }
      
      // Loop through each ticket and update the corresponding year and month
      tickets.forEach((item) => {
        const ticketDate = new Date(item.created_at);
        const year = ticketDate.getFullYear();
        const monthIndex = ticketDate.getMonth(); // Get month index (0-11)
        
        // Increment the ticket count for the corresponding month and year
        if (yearlyData[year]) {
          yearlyData[year][monthIndex].ticket++;
        }
      });
      
      return yearlyData;
    }
  };

  let newAllTickets;
  let lineData;
  const fetchYearlyData = async () => {
    try {
      const response = await fetch(`${url}api/ticket/getYearlyData`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      });
      const data = await response.json();
      if (data.success) {
        setAllTickets(data.data);
      }
    } catch (error) {
      console.error("Error fetching yearly data:", error);
    }
  };
  
  lineData = generateYearlyData(allTickets);
  // const lineData = fetchData();

  const monthsLine = Array.from({ length: 12 }, (v, i) => ({
    month: new Date(0, i).toLocaleString("en-US", { month: "long" }),
    Generated: 0,
    In_Progress: 0,
    Completed: 0,
  }));

  const countDatesByMonthLine = (tickets, months) => {
    const monthCounts = monthsLine.map((month) => ({
      ...month,
      Generated: 0,
      In_Progress: 0,
      Completed: 0,
    }));

    tickets.forEach((ticket) => {
      const monthIndex = new Date(ticket.created_at).getMonth();
      if (ticket.status === "generated") {
        monthCounts[monthIndex].Generated++;
      } else if (ticket.status === "in progress") {
        monthCounts[monthIndex].In_Progress++;
      } else if (ticket.status === "completed") {
        monthCounts[monthIndex].Completed++;
      }
    });

    return monthCounts;
  };

  const multiLine = countDatesByMonthLine(allTickets, months);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-5 col-12 mb-3">
            <CategoryPie
              data={user.role === "employee" ? analyticsData : chartData}
              user={user}
              total={tickets.length}
            />
          </div>
          <div className="col-lg-8 col-md-7 col-12 mb-3">
            <TicketChart data={lineData} />
          </div>
          {/* <div className="col-lg-5 col-12 mb-3">
            <div className="d-flex flex-column" style={{ gap: "20px" }}>
              <MultipleLine data={multiLine} />
            </div>
          </div>*/}
        </div>
        <div className="row">
          <div className={styles.analyticsContainer}>
            <h5 className="mb-2">
              {user.role === "employee" ? "Your" : "Employee"} Analytics
            </h5>
            {userAnalytics.map((user, index) => (
              <div key={index} className={styles.analyticsCard}>
                <div className="d-flex flex-column align-items-start">
                  <div className={styles.userInfo}>
                    <div className={styles.avatarCircle}>
                      {user.user.picture ? (
                        <img
                          src={
                            process.env.REACT_APP_API_URL +
                            `uploads/${user.user.picture}`
                          }
                          alt=""
                        />
                      ) : (
                        getInitials(user.user.name)
                      )}
                    </div>
                    <div className={styles.userDetails}>
                      <h6>{user.user.name}</h6>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-between w-100 mt-2">
                    <div className={styles.statusInfo}>
                      <span
                        className={`${styles.statusCircle} ${styles.overdue}`}
                      >
                        Overdue: {user.analytics.overdue}
                      </span>
                      <span
                        className={`${styles.statusCircle} ${styles.pending}`}
                      >
                        Pending: {user.analytics.pending}
                      </span>
                      <span
                        className={`${styles.statusCircle} ${styles.inProgress}`}
                      >
                        In Progress: {user.analytics.inprogress}
                      </span>
                      <span
                        className={`${styles.statusCircle} ${styles.completed}`}
                      >
                        Completed: {user.analytics.completed}
                      </span>
                      <span
                        className={`${styles.statusCircle} ${styles.completed}`}
                      >
                        On Time: {user.analytics.submittedOnTime}
                      </span>
                      <span
                        className={`${styles.statusCircle} ${styles.overdue}`}
                      >
                        Delayed: {user.analytics.delayed}
                      </span>
                    </div>
                  </div>
                </div>
                <div className={styles.performance}>
                  <CircularProgressbar
                    value={user.analytics.performance}
                    text={`${user.analytics.performance}%`}
                    styles={buildStyles({
                      pathColor:
                        user.analytics.performance >= 80
                          ? "green"
                          : user.analytics.performance >= 60
                          ? "orange"
                          : "red", // 0-60: red, 60-80: orange, 80 and above: green
                      textColor:
                        user.analytics.performance >= 80
                          ? "green"
                          : user.analytics.performance >= 60
                          ? "orange"
                          : "red", // Match text color to path color
                      trailColor: "#d6d6d6",
                      backgroundColor: "#f3f4f6",
                    })}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Analytics;
